export interface Restaurant {
  id?: string;
  title: string;
  description: string;
  imageUrl?: string;
  rating?: number;
  michelinStars: number;
  addressFull?: string;
  addressShort?: string;
  addressMetadata?: any;
  city?: string;
  country?: string;
  latitude?: number;
  longitude?: number;
  websiteUrl?: string;
  bookingUrl?: string;
  pricePoint?: number;
  cuisines: Cuisine[];
  images: Image[];
  quotes: Quote[];
  searchable?: boolean;
  googlePlaceId?: string;
  isCertified?: boolean;
}

export interface GoogleSearchResult {
  googlePlaceId: string;
  title: string;
  address: string;
  rating?: number;
  pricePoint?: number;
  isFromGoogle: boolean;
}

export interface LocalSearchResult {
  id: string;
  title: string;
  address: string;
  addressFull?: string;
  rating?: number;
  isCertified?: boolean;
  imageUrl?: string;
}

export interface Cuisine {
  id?: string;
  title: string;
}

export interface Image {
  id: string;
  url: string;
}

export interface Quote {
  id: string;
  text: string;
  author: string;
}

export enum Sentiment {
  Unknown = '',
  KeenToGo = 'keen',
  NotInterested = 'not_interested',
}
